import { wishlistEvent } from 'snippets/wishlist/selected'

/**
 * This is the event listener for the wishlist added event
 * @param {CustomEvent} element - The event object
 */
const wishListEventListener = async (element) => {
  setTimeout(() => {
    const getItemId = (storedItemString) => {
      try {
        const [id, _] = storedItemString.split(':')
        return id
      } catch (error) {
        console.error('Error getting item id', error)
        return null
      }
    }

    const findProductDetailsFromDatalayer = (itemId, lookupDataLayerEvent) => {
      const productDetails = window.BCDataLayerManager?.utils?.findInDataLayer(itemId, null, lookupDataLayerEvent)
      return productDetails
    }
    const wishlistItem = element.detail
    const lookUpEvents = ['view_item_list', 'view_item']
    // Lookup for the product details in the datalayer for both view_item_list and view_item
    lookUpEvents.forEach((lookupDataLayerEvent) => {
      const itemId = getItemId(wishlistItem)
      if (!itemId) {
        return
      }
      const productDetails = findProductDetailsFromDatalayer(parseInt(itemId), lookupDataLayerEvent)
      if (productDetails) {
        const payload = {
          currency: window.BCDataLayerManager?.manager?.site?.getData()?.currency || 'AUD',
          save: {
            value: productDetails.price,
            items: [
              {
                ...productDetails
              }
            ]
          }
        }
        // Push the event to the datalayer
        window.BCDataLayerManager?.manager?.eventNotification?.pushEcommerceEvent('save_product', payload)
      }
    })
  }, 100)
}

/**
 * This is the event listener for the wishlist added event for both view_item_list and view_item
 * @param {CustomEvent} element - The event object
 */
document.addEventListener(wishlistEvent.WISHLIST_ADDED, wishListEventListener)
